import saveAs from 'file-saver'
import { api } from 'store/modules/fileAttachments'

const handleProgress = (onDownloadProgress) => (e) => {
  if (e.lengthComputable) {
    onDownloadProgress(Math.round((e.loaded / e.total) * 100))
  }
}

export function downloadFile (fileAttachment, onDownloadProgress, onError) {
  api.downloadFile(fileAttachment.id, handleProgress(onDownloadProgress)).then(response => {
    try {
      const contentType = fileAttachment.contentType || 'application/octet-stream'
      const blob = new window.Blob([response.data], { type: `${contentType};charset=UTF-8` })
      saveAs(blob, fileAttachment.fileName)
    } catch (err) {
      console.log('error1: ', err)
      onDownloadProgress(0)
      if (typeof onError === 'function') { onError(err) }
    }
  }).catch(err => {
    console.log('error2: ', err)
    onDownloadProgress(0)
    if (typeof onError === 'function') { onError(err) }
  })
}
